import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoPa: CultureInfo = {
  name: 'pa',
  displayName: 'Punjabi',
  iso3LanguageCode: 'pan',
  iso2LanguageCode: 'pa',
  ietfLanguageTag: 'pa',
  parent: null
};
